import { Controller } from "@hotwired/stimulus"
import Preferences from "../models/preferences"

export default class extends Controller {
  static targets = ["listView", "kanbanView", "listIcon", "kanbanIcon"]

  connect() {
    this.setView(Preferences.propertiesViewMode)
  }

  toggle() {
    const newView = Preferences.propertiesViewMode === "list" ? "kanban" : "list"
    this.setView(newView)
    Preferences.propertiesViewMode = newView
  }

  setView(view) {
    if (this.hasListViewTarget && this.hasKanbanViewTarget) {
      this.listViewTarget.classList.toggle("hidden", view !== "list")
      this.kanbanViewTarget.classList.toggle("hidden", view !== "kanban")
    }

    if (this.hasListIconTarget && this.hasKanbanIconTarget) {
      this.listIconTarget.classList.toggle("hidden", view !== "list")
      this.kanbanIconTarget.classList.toggle("hidden", view !== "kanban")
    }
  }
}
